import { Language } from '@coolblue-development/constants';
export const MAX_NICHE_HEIGHT = 93;
export const MIN_NICHE_HEIGHT = 45;
export const MIN_PANEL_HEIGHT = 50.8;
export const MAX_PANEL_HEIGHT = 82.5;
export const MAX_BOTTOM_DOOR_HEIGHT = 77.9;
export const MIN_BOTTOM_DOOR_HEIGHT = 61;
export const MAX_NICHE_HEIGHT_FRIDGES = 178;
export const MIN_NICHE_HEIGHT_FRIDGES = 82;
export const validationStates = {
    success: 'success',
    panelError: 'panelError',
    nicheError: 'nicheError',
    hingeSystemError: 'hingeSystemError',
    bottomPanelError: 'bottomPanelError',
};
export const DISHWASHER_FILTER_SLUG = {
    [Language.DUTCH]: 'vaatwassers/filter/inbouw',
    [Language.ENGLISH]: 'dishwashers/filter/built-in',
    [Language.FRENCH]: 'lave-vaisselle/filter/encastrable',
    [Language.GERMAN]: 'spuelmaschinen/filter/einbau',
};
export const FRIDGE_FILTER_SLUG = {
    [Language.DUTCH]: 'koelkasten/filter/inbouw',
    [Language.ENGLISH]: 'fridges/filter/built-in',
    [Language.FRENCH]: 'refrigerateurs/filter/encastrable',
    [Language.GERMAN]: 'kuehlschraenke/filter/einbau',
};
export const DISH_WASHER_PRODUCT_TYPE_ID = '2679';
export const FRIDGES_PRODUCT_TYPE_ID = '2676';
export const PANEL_HEIGHT_PROPERTY_ID = '583681';
export const NICHE_HEIGHT_PROPERTY_ID = '583677';
export const HINGE_SYSTEM_PROPERTY_ID = '21144';
export const BOTTOM_DOOR_HEIGHT_PROPERTY_ID = '583680';
export const HINGE_SYSTEM_SLIDE_DOOR = [
    'Sliding door',
    'Sleepdeur',
    'Porte coulissante',
    'Schlepptür',
];
export const HINGE_SYSTEM_DOOR_ON_DOOR = [
    'Door-on-door',
    'Deur-op-deur',
    'Porte-sur-porte',
    'Festtür',
];
//# sourceMappingURL=constants.js.map